"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class OccupancySchedule extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'occupancySchedule';
        this._name = initParams.name;
        this._schedule = initParams.schedule;
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateOccupancySchedule(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set schedule(value) {
        console.error('Do not set objects this way');
    }
    setSchedule(value) {
        return this.dataService.updateOccupancySchedule(this.id, { schedule: value }, this);
    }
    get schedule() {
        return this._schedule;
    }
    set siteIds(value) {
        console.error('Do not set objects this way');
    }
    setSiteIds(value) {
        return this.dataService.updateOccupancySchedule(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get siteIds() {
        return this._siteIds;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateOccupancySchedule(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOccupancySchedule(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteOccupancySchedule(this.id, this);
    }
}
exports.default = OccupancySchedule;
//# sourceMappingURL=occupancySchedule.js.map